/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../reducers';
import { getInitiativeGroupTree } from '@selectors/initiativeTree';
import { isPortfolioTrackerExchange } from '@selectors/portfolio';
import { loadPortfolioCompanies } from '../../../../slice/portfolioCompanySlice';
import { loadPortfolioById } from '../../../../slice/portfolioSlice';
import { Loader } from '@g17eco/atoms/loader';
import { ExchangeView } from './exchange-view';
import { InvestorView } from './investor-view';
import './styles.scss';


export const PortfolioRoute = () => {
  const dispatch = useAppDispatch();
  const { portfolioId } = useParams<{ portfolioId: string }>();
  const initiativeTree = useAppSelector(getInitiativeGroupTree);

  const { data: portfolio, loaded: isLoaded, loading } = useAppSelector((state) => state.portfolio);
  const isFullyLoaded = isLoaded && !loading;
  const isExchangeView = useAppSelector(isPortfolioTrackerExchange);

  React.useEffect(() => {
    dispatch(loadPortfolioById(portfolioId));
    dispatch(loadPortfolioCompanies(portfolioId));
  }, [dispatch, portfolioId]);

  if (!portfolio || !isFullyLoaded) {
    return <Loader />;
  }

  if (isExchangeView) {
    return <ExchangeView portfolio={portfolio} />;
  }

  return <InvestorView initiativeTree={initiativeTree} portfolio={portfolio} />;
};
